import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useActivationState } from '@/hooks/useActivationState';

interface ProtectedRouteProps {
  children: React.ReactNode;
  skipActivationCheck?: boolean;
}

export function ProtectedRoute({ children, skipActivationCheck = false }: ProtectedRouteProps) {
  const { auth } = useAuth();
  const { setupCompleted, isLoading: activationLoading, hasError } = useActivationState();

  // Check localStorage directly to compare with auth state
  const localJWT = localStorage.getItem('sparkry_jwt');
  const localUserId = localStorage.getItem('sparkry_userId');

  console.log('[ProtectedRoute] Auth state:', {
    isLoading: auth.isLoading,
    isAuthenticated: auth.isAuthenticated,
    hasUserId: !!auth.userId,
    hasJWT: !!auth.jwt,
  });

  console.log('[ProtectedRoute] localStorage state:', {
    hasJWT: !!localJWT,
    hasUserId: !!localUserId,
    jwtPreview: localJWT?.substring(0, 20) + '...',
  });

  if (auth.isLoading) {
    console.log('[ProtectedRoute] Still loading, showing spinner');
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    console.log('[ProtectedRoute] Not authenticated, redirecting to /login');
    console.log('[ProtectedRoute] BUT localStorage has tokens?', {
      hasJWT: !!localJWT,
      hasUserId: !!localUserId,
    });
    return <Navigate to="/login" replace />;
  }

  // If activation check failed due to errors (e.g., 401, network issues),
  // allow navigation with a warning instead of blocking the user
  if (!skipActivationCheck && hasError) {
    console.warn('[ProtectedRoute] Activation check failed due to errors, allowing navigation');
    // User is authenticated but we can't verify setup - fail open
    return <>{children}</>;
  }

  // Check activation state (unless skipActivationCheck is true)
  if (!skipActivationCheck && !activationLoading && !setupCompleted) {
    console.log('[ProtectedRoute] Setup not complete, redirecting to /setup');
    return <Navigate to="/setup" replace />;
  }

  console.log('[ProtectedRoute] Authenticated, rendering protected content');
  return <>{children}</>;
}
